import React from 'react'
import { Link } from 'gatsby'

import logo from '../images/lilo_web_logo.png'
import emailIcon from '../images/iconmonstr-email-4.svg'
import phoneIcon from '../images/iconmonstr-phone-1.svg'
// import bbbLogo from '../images/bbb-logo.png'
import facebook from '../images/facebook-icon-cyan.png'
import twitter from '../images/twitter-icon-cyan.png'
import insta from '../images/insta-icon-cyan.png'
import linkedin from '../images/linkedin-icon-cyan.png'

const NavbarView = ({ on_menu_button_click }) => {
  return (
    <div className="fixed z-40 w-full tracking-wider">
      <div className="bg-azul">
        <div className="container px-4 lg:px-0">
          <div className="py-2 text-white md:text-lg text-center">
            Buy a 64 oz Lilo Hand Sanitizer and Liloclean will donate a bottle to frontline workers. <a className="underline" href="tel:1-203-930-2154">CALL NOW</a>
          </div>
        </div>
      </div>
      <div className="bg-lightgray">
        <nav className="container px-4 lg:px-0">
          <div className="flex">
            <div className="w-1/4 md:w-1/6">
              <div className="pt-4 absolute">
                <Link to="/"><img id="navbar-logo" width={120} height={120} className="h-20 md:h-28 lg:h-32" src={logo} alt="Lilo Clean Logo" /></Link>
              </div>
            </div>
            <div className="w-3/4 md:w-5/6 flex-initial lg:flex py-4 md:py-8 justify-end">
              <div className="flex-none md:flex font-light text-xl lg:text-2xl mr-64">
                <div className="hidden md:flex py-1">
                  <span>a&nbsp;</span><a className="lilogo" href="https://www.lilogy.com" target="_blank" rel="noreferrer">&nbsp;</a><span>&nbsp;company</span>
                </div>
              </div>
              <div className="flex py-1 md:hidden">
                <div className="mr-4 md:mx-4">
                  <a href="https://www.facebook.com/liloclean" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={facebook} alt="Facebook" /></a>
                </div>
                <div className="mr-4">
                  <a href="https://twitter.com/LiIogy" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={twitter} alt="Twitter" /></a>
                </div>
                <div className="mr-4">
                  <a href="https://www.instagram.com/liloclean/" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={insta} alt="Instagram" /></a>
                </div>
                <div className="mr-4">
                  <a href="https://www.linkedin.com/company/lilogy/" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={linkedin} alt="LinkedIn" /></a>
                </div>
                <button className="flex items-center px-3 py-2 border-2 rounded border-azul text-azul hover:border-azul-dark hover:text-azul-dark" onClick={on_menu_button_click}>
                  <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
                </button>
              </div>
              <div className="flex">
                <div className="flex-none md:flex font-light text-xl lg:text-2xl">
                  <a href="tel:1-203-930-2154" className="hover:text-darkazul flex items-center py-1">
                    <span className="mr-4"><img src={phoneIcon} style={{ height: 32, width: 32 }} alt="Phone Icon" /></span>
                    <span className="mr-4">203.930.2154</span>
                  </a>
                  <a href="mailto:sales@lilogy.com" className="hover:text-darkazul flex items-center py-1">
                    <span className="mr-4"><img src={emailIcon} style={{ height: 32, width: 32 }} alt="Email Icon" /></span>
                    <span className="">sales@lilogy.com</span>
                  </a>
                </div>
                <div className="hidden md:flex justify-start md:justify-center items-center pt-2 md:pt-0">
                  <div className="mr-4 lg:mx-4">
                    <a href="https://www.facebook.com/liloclean" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={facebook} alt="Facebook" /></a>
                  </div>
                  <div className="mr-4">
                    <a href="https://twitter.com/LiIogy" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={twitter} alt="Twitter" /></a>
                  </div>
                  <div className="mr-4">
                    <a href="https://www.instagram.com/liloclean/" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={insta} alt="Instagram" /></a>
                  </div>
                  <div className="">
                    <a href="https://www.linkedin.com/company/lilogy/" target="_blank" rel="noreferrer"><img style={{ height: 32, width: 32 }} src={linkedin} alt="LinkedIn" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default NavbarView
